export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_MENU_OFF = 'COLLAPSE_MENU_OFF';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

export const RESET = 'RESET';
export const HANDLE_EMPLOYEES = 'HANDLE_EMPLOYEES';
export const HANDLE_VEHICLE_LIST = "HANDLE_VEHICLE_LIST";
export const HANDLE_DESIGNATION = "HANDLE_DESIGNATION";
export const HANDLE_DISTRIBUTOR = "HANDLE_DISTRIBUTOR";
export const HANDLE_BIT_DISTRIBUTOR = "HANDLE_BIT_DISTRIBUTOR";
export const HANDLE_CLEAR_AGENT = "HANDLE_CLEAR_AGENT";

export const HANDLE_POINT_DETAILS = "HANDLE_POINT_DETAILS";
export const RESET_POINT_DETAILS = "RESET_POINT_DETAILS";

export const HANDLE_EXPENSE = "HANDLE_EXPENSE";
export const HANDLE_DIESEL = "HANDLE_DIESEL";



export const HANDLE_FORM = "HANDLE_FORM";
export const RESET_FORM = "RESET_FORM";

export const HANDLE_AGENT_DETAILS = "HANDLE_AGENT_DETAILS";
export const HANDLE_VEHICLE = 'HANDLE_VEHICLE';

export const HANDLE_USER = 'HANDLE_USER';
export const HANDLE_EMPLOYEE = 'HANDLE_EMPLOYEE';
export const HANDLE_AGENT = 'HANDLE_AGENT';
export const HANDLE_BIT = "HANDLE_BIT";
export const HANDLE_HAMMER = "HANDLE_HAMMER";
export const HANDLE_POINT_ADDRESS = "HANDLE_POINT_ADDRESS";


export const HANDLE_COMPANY = "HANDLE_COMPANY";
export const HANDLE_COMPANY_DETAIL = "HANDLE_COMPANY_DETAIL";
export const HANDLE_DEVICE_DATA = "HANDLE_DEVICE_DATA";

export const HANDLE_ALERT_LOG = "HANDLE_ALERT_LOG";

export const HANDLE_CONFIGURATION = "HANDLE_CONFIGURATION";